import { IUserPermission } from "../types";

// TODO: 之後可以刪除這些數組，也可以作為fallback
const TEMP_ADMIN: IUserPermission[] = [
    {
        email: "mulit.amaze@gmail.com",
        role: "admin",
    },
    {
        email: "jan07160716@gmail.com",
        role: "admin",
    },
    {
        email: "clairema@thebarkingdog-games.com",
        role: "admin",
    },
    {
        email: "aiamaze.test@outlook.com",
        role: "admin",
    },
    {
        email: "dragonball880630@gmail.com",
        role: "admin",
    },
    {
        email: "unitytest.amaze@outlook.com",
        role: "admin",
    }
];

// > 靜態備援配置 - 當動態配置失敗時使用
export const USER_PERMISSION_CONFIG: IUserPermission[] = [
    ...TEMP_ADMIN,

    // Users
    {
        email: "AA24014B0103.aiamaze@outlook.com",
        role: "user",
        projectLimits: null,
    },
    {
        email: "ac24001b0101.aiamaze@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "SA24003b0101.aiamaze@outlook.com",
        role: "user",
        projectLimits: 50,
    },
    {
        email: "youngman.aiamaze@gmail.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "AA240312b0101.aiamaze@outlook.com",
        role: "user",
        projectLimits: 5,
    },
    {
        email: "laa23001b0101aiamaze@gmail.com",
        role: "user",
        projectLimits: 2,
    },

    {
        email: "aa10020.aiamaze@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "honmyue@barkingdog.ai",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "AA240313b0101.aiamaze@outlook.com", // 南仁湖
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100026.aiamaze@outlook.com", // 高科大教學
        role: "user",
        projectLimits: 27,
    },
    {
        email: "aa100222.aiamaze@outlook.com", // 中央大學
        role: "user",
        projectLimits: 6,
    },
    {
        email: "aa100202.aiamaze@outlook.com", // 圓宸雲端科技有限公司
        role: "user",
        projectLimits: 9,
    },
    {
        email: "AA10020.ai@outlook.com", // 文藻 1
        role: "user",
        projectLimits: 5,
    },
    {
        email: "AA1002002.ai@outlook.com", // 文藻 2
        role: "user",
        projectLimits: 5,
    },
    {
        email: "AA1002002.ai+02@outlook.com", // 2025-12-06 新增
        role: "user",
        projectLimits: 3,
    },
    {
        email: "AA1002003.ai@outlook.com", // 文藻 3
        role: "user",
        projectLimits: 5,
    },
    {
        email: "AA1002004.ai@outlook.com", // 文藻 4
        role: "user",
        projectLimits: 5,
    },
    {
        email: "AA1002005.ai@outlook.com", // 文藻 5
        role: "user",
        projectLimits: 6,
    },
    {
        email: "aa100026.aiamaze+1@outlook.com", // 高科大
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100268.aiamaze@outlook.com", // CTCSP
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+15@outlook.com", // 圓宸_北新國小
        role: "user",
        projectLimits: 30,
    },
    {
        email: "aa100330.aiamaze@outlook.com", // 易福社會創新
        role: "user",
        projectLimits: 2,
    },
    {
        email: "bd.demo7@outlook.com", // BD Demo
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+36@outlook.com", // 三民高中
        role: "user",
        projectLimits: 32,
    },
    {
        email: "aa100202.aiamaze+37@outlook.com", // 圓宸_嘉義高工
        role: "user",
        projectLimits: 5,
    },
    {
        email: "aa100130.aiamaze@outlook.com", // 中市府
        role: "user",
        projectLimits: 10,
    },
    {
        email: "aa100136.aiamaze@outlook.com", // 台資服_公司介紹
        role: "user",
        projectLimits: 5,
    },
    {
        email: "aa100324.care.aiamaze@outlook.com", // 精科長照案
        role: "user",
        projectLimits: 60,
    },
    {
        email: "aa100202.aiamaze+20@outlook.com", // 1146-[圓宸]開通新增
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa10020201.ai@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa10020202.ai@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa10020203.ai@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa10020204.ai@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa10020205.ai@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+01@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+02@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+03@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+04@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+05@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+16@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+17@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+18@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+19@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+21@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+22@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+23@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+24@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+25@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+26@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+27@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+28@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+29@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+30@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+31@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+32@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+33@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+34@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+35@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100202.aiamaze+36@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100218.aiamaze+02@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100218.aiamaze+03@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100218.aiamaze+04@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100218.aiamaze+05@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100218.aiamaze+06@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100218.aiamaze+07@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100386.aiamaze@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo4@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "bd.demo18@outlook.com",
        role: "user",
        projectLimits: 5,
    },
    {
        email: "bd.demo151@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo182@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo183@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo184@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo185@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo186@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo187@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo188@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo189@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo190@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo191@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo192@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo193@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo194@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo195@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo196@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo197@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo198@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo199@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo200@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo201@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo202@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo203@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo204@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo25@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "bd.demo205@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo206@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo207@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo208@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo209@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo210@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo211@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo212@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo213@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo214@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo215@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo216@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo217@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo218@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo219@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo220@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo221@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo222@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo223@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo224@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo225@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo226@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo227@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo228@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo229@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo230@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo231@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "bd.demo493@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100198.aiamaze@outlook.com",
        role: "user",
        projectLimits: 3,
    },
    {
        email: "wistronxamaze@gmail.com",
        role: "user",
        projectLimits: 11,
    },
    {
        email: "bd.demo304@outlook.com",
        role: "user",
        projectLimits: 4,
    },
    {
        email: "bd.demo305@outlook.com",
        role: "user",
        projectLimits: 4,
    },
    {
        email: "bd.demo306@outlook.com",
        role: "user",
        projectLimits: 4,
    },
    {
        email: "bd.demo307@outlook.com",
        role: "user",
        projectLimits: 4,
    },
    {
        email: "bd.demo308@outlook.com",
        role: "user",
        projectLimits: 4,
    },
    {
        email: "bd.demo309@outlook.com",
        role: "user",
        projectLimits: 4,
    },
    {
        email: "bd.demo310@outlook.com",
        role: "user",
        projectLimits: 4,
    },
    {
        email: "bd.demo311@outlook.com",
        role: "user",
        projectLimits: 4,
    },
    {
        email: "bd.demo312@outlook.com",
        role: "user",
        projectLimits: 4,
    },
    {
        email: "bd.demo313@outlook.com",
        role: "user",
        projectLimits: 4,
    },
    {
        email: "bd.demo314@outlook.com",
        role: "user",
        projectLimits: 4,
    },
    {
        email: "bd.demo315@outlook.com",
        role: "user",
        projectLimits: 4,
    },
    {
        email: "bd.demo392@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aconjapan.aiamaze@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100373.nanshan@outlook.com",
        role: "user",
        projectLimits: 4,
    },
    {
        email: "aa100373.aiamaze@outlook.com",
        role: "user",
        projectLimits: 2,
    },
    {
        email: "aa100373.tps@outlook.com",
        role: "user",
        projectLimits: 2
    },
    {
        email: "aa100373.tps@outlook.com",
        role: "user",
        projectLimits: 2
    },
    {
        email: "aa100242.aiamaze@outlook.com",
        role: "user",
        projectLimits: 2
    },
    {
        email: "aa100242.skm.cg@outlook.com",
        role: "user",
        projectLimits: 2
    },
    {
        email: "aa100242.skmtxp@outlook.com",
        role: "user",
        projectLimits: 8
    },
    {
        email: "aa100324.chiayisteel@outlook.com",
        role: "user",
        projectLimits: 2
    },
    // 實習生專用
    {
        email: "bd.demo30@outlook.com",
        role: "user",
        projectLimits: 20
    },
    {
        email: "bd.demo32@outlook.com",
        role: "user",
        projectLimits: 20
    },
    {
        email: "bd.demo33@outlook.com",
        role: "user",
        projectLimits: 20
    },
];
